import { render, staticRenderFns } from "./AddressFormat.vue?vue&type=template&id=05d615bf&"
import script from "./AddressFormat.vue?vue&type=script&lang=js&"
export * from "./AddressFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports